<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form class="fn-clear" :inline="true">

          <!-- <el-form-item label="" class="fn-left">
            <el-checkbox v-model="listQuery.tll_status" true-label="20062018214508001072" false-label="">只看已无效的例子</el-checkbox>
          </el-form-item> -->
          <el-form-item class="fn-left">
            <wq-select :selected.sync="listQuery.shop_id" placeholder="请选择校区" value-name="id" text-name="name" :data-func="$http.getShopList" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="success" @click="$refs['puchseupdateexpresslisttable'].fetchTableData() ">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <wq-table ref="puchseupdateexpresslisttable" show-page sub-key="list" :other-query="listQuery" :url-func="$http.notHaveExpressInfoPackageList" @data-from-server="fnUpdateExpressLists">
        <el-table-column label="店铺" prop="shop_name" align="center" />
        <el-table-column label="包裹ID" prop="id" align="center" />
        <el-table-column label="合约ID" prop="receiver" align="center">
          <template slot-scope="{row}">
            <span>{{ row.purchase_type_name }}(ID:{{ row.note_id }})</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" align="center" />
        <el-table-column label="已打包物品" align="center" width="150px">
          <template slot-scope="{row}">
            <div v-for="item in row.order_list" :key="item.name+item.goods_id">{{ item.goods_name }}(数量: {{ item.num }})</div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="最新物流信息" prop="receiver" align="center">
          <template slot-scope="{row}">
            <span v-if="row.express_info.orderNo"> {{ row.express_info.info[0].theLastMessage }} </span>
            <span v-if="!row.express_info.orderNo"> {{ showLastMsg(row.express_info.Traces) }} </span>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" align="center" width="220px">
          <template slot-scope="{row}">
            <el-button type="primary" size="small" @click="fnExpress(row)">填写快递信息</el-button>
          </template>
        </el-table-column>
      </wq-table>

    </div>
    <el-dialog
      title="填写快递信息"
      :visible.sync="dialogVisible"
      width="80%"
    >

      <form-box ref="expressforms" key="expressforms" label-width="120px" :forms="expressForms" :post-form="expressPostForm" @submit="fnUpdateExpressSumbit">
        <template v-slot:express_code="{currentForm, item}">
          <wq-select :placeholder="`请选择${item.label}`" :columns="expressLists" :name="item.bindValue" :selected.sync="currentForm[item.bindValue]" value-name="value" text-name="label" />
        </template>
      </form-box>
    </el-dialog>
  </div>

</template>
<script>

const defaultPackagePostForm = {
  package_id: '',
  express_code: '',
  express_no: '',
  remark: ''
}
import FormBox from '@/components/FormBox'
import WqSelect from '@/components/FormBox/WqSelect'
import WqTable from '@/components/WqTable'
export default {
  name: 'TurnStudentList',
  components: {
    // Select
    WqTable,
    WqSelect,
    FormBox
  },

  data() {
    return {
      lists: [],
      listQuery: {
        shop_id: '',
        status: 1,
        purchase_type: ''
      },
      expressForms: [
        { type: 'custom', label: '快递公司', bindValue: 'express_code', require: true },
        { type: 'input', label: '快递单号', bindValue: 'express_no', require: true },
        { type: 'input', label: '备注', bindValue: 'remark', require: true }
      ],
      expressPostForm: Object.assign({}, defaultPackagePostForm),
      statusLists: [{ id: 1, name: '未收货' }, { id: 2, name: '已收货' }],
      auditMessage: '',
      dialogVisible: false,
      currentAudit: {
        note_id: '',
        result: '',
        comment: ''
      },
      expressLists: [],
      tableKey: 0
    }
  },
  created() {
    // this.fnGetExpressLists()
  },
  methods: {
    fnUpdateExpressLists(res) {
      this.expressLists = this.fnConvertObjectToArray(res.express_list)
    },
    fnConvertObjectToArray(objs) {
      const ary = []
      console.log(objs)
      for (const key in objs) {
        ary.push({ value: key, label: objs[key] })
      }
      console.log(ary)
      return ary
    },
    fnExpress(row) {
      this.expressPostForm = Object.assign({}, defaultPackagePostForm, { package_id: row.id })
      this.dialogVisible = true
    },
    fnUpdateExpressSumbit(postForm) {
      this.$http.confirmExpressInfo(postForm).then((res) => {
        if (res.code == 200) {
          this.$message({ type: 'success', message: '单号填写!' })
          this.dialogVisible = false
          this.$refs['puchseupdateexpresslisttable'].fetchTableData()
        }
      })
    }
  }
}
</script>
<style lang="scss">
.el-image-viewer__wrapper .el-icon-circle-close {
  color:white
}
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
